<template>
  <div>
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header> 
    <el-main  v-loading.fullscreen.lock="loading">
      <h3>Applicant Information</h3>
      <el-form ref="form" :model="form" label-width="150px" :rules="rules">        
        <el-row>             
          <el-col :span="24" style="text-align:right;padding-bottom:10px">
            <el-button type="danger" @click="docDelete"  size="small" v-if="canDelete">{{$t('button.docDelete')}}</el-button><!--作廢-->
            <el-button type="warning" @click="save"  size="small" v-if="canSave">{{$t('button.save')}}</el-button>
            <el-button type="success" @click="submit"  size="small" v-if="canSubmit">{{$t('button.submit')}}</el-button>        
            <el-button type="success" @click="forward"  size="small" v-if="canApprove">{{$t('button.forward')}}</el-button>
            <el-button type="success" @click="approve"  size="small" v-if="canApprove">{{$t('button.approve')}}</el-button>
            <el-button type="danger" @click="reject"  size="small" v-if="canReject">{{$t('button.reject')}}</el-button>
            <el-button type="warning" @click="sendMail"  size="small" v-if="canSendMail">{{$t('button.sendMail')}}</el-button>
          </el-col>
        </el-row>
        <el-row>    
          <el-col :span="8">
            <el-form-item :label="$t('field.docNo')">
              <el-input v-model="form.requestNo" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('field.applyDate')">
              <el-input v-model="form.applyDateStr" :disabled="true"></el-input>          
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('field.docStatus')" >
              <el-input v-model="form.status" :disabled="true"></el-input>    
            </el-form-item>
          </el-col>             
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$t('field.requestAccount')" >
              <el-input v-model="form.applyAccount" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('field.dept')">
              <el-input v-model="form.applyDept" :disabled="true"></el-input>    
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('field.tel')" >
              <el-input v-model="form.applyExtNo" :disabled="true"></el-input>    
            </el-form-item>
          </el-col>             
        </el-row>  
        <h3>Revision Information</h3>  
        <el-row>
          <el-col :span="16">
            <el-form-item prop="crNo" :label="$t('field.crRequestNo')">
              <CRSearch :pSelectValue.sync="form.crNo"  @sync-select-cr="syncSelectCR"  :pOnlyView="onlyView" pStatusCondition="closed"/>     
            </el-form-item>
          </el-col>
        </el-row>    
        <el-row>
          <el-col :span="16">
            <el-form-item :label="$t('field.crReason')" >
              <el-input v-model="crData.reason" :disabled="true"></el-input>          
            </el-form-item>
          </el-col>
        </el-row> 
        <el-row>
          <el-col :span="16">
            <el-form-item label='Target'>
              <el-input v-model="crData.target" :disabled="true"></el-input>          
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label='Target Type'>
              <el-input v-model="crData.targetType" :disabled="true"></el-input>          
            </el-form-item>
          </el-col>
        </el-row> 
        <el-row> 
          <el-col :span="24">
            <el-form-item label='Model Name'>
              <el-input v-model="crData.modelName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row> 
        <el-row>
          <el-col :span="24">
            <el-form-item  :label="$t('field.description')" >
              <el-input type="textarea" v-model="crData.description"  :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row> 
        <el-row>    
          <el-col :span="8">
            <el-form-item label='PM'>
              <el-input v-model="crData.pm" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label='ECR No'>
              <el-input v-model="crData.ecrNo" :disabled="true"></el-input>          
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label='ECN No'>
              <el-input v-model="crData.ecnNo" :disabled="true"></el-input>          
            </el-form-item>
          </el-col>
        </el-row>
        <FileEditList ref="fileList" :onlyView="true" :docId.sync="form.crId" uploadType="cr" />
        <br>
        <div v-if="crData.targetType != targetType[0] && crData.targetType != targetType[7] " class="specialAreaStyle" style="overflow-y: hidden; !important">
          <el-row >
            <el-col :span="12" v-if="crData.targetType == targetType[4] || crData.targetType == targetType[5] || crData.targetType == targetType[6]">   
              <el-form-item :label="$t('field.currentVersion')" required>          
                <el-select  :placeholder="$t('msg.pleaseSelect')" style="width:98%" v-model="form.currentVersion" :disabled="onlyView">
                  <el-option v-for="v in currentVersionOpts"  :key="v"  :label="v" :value="v"></el-option>
                </el-select> 
              </el-form-item>
            </el-col>  
            <el-col :span="12">
              <el-form-item :label="$t('field.updatedTo')" required > <!-- prop="updateTo" -->
                <el-select  :placeholder="$t('msg.pleaseSelect')" style="width:98%" v-model="form.updateTo" :disabled="onlyView">
                  <el-option v-for="v in updateToOpts"  :key="v"  :label="v" :value="v"></el-option>
                </el-select>  
              </el-form-item>
            </el-col>          
          </el-row>
        </div>
        <div v-if="crData.targetType == targetType[0]" class="specialAreaStyle" >
          <el-row :gutter="10" v-for="(item, index) in crData.modelNameArr" :key="index">
            <el-col :span="8">   
              <el-form-item label='Model Name' required>
                <el-input :disabled="true" :value="item"> </el-input>          
              </el-form-item>
            </el-col>
            <el-col :span="13"  v-if="crData.modelNameMap != '' && crData.modelNameMap != undefined && crData.modelNameMap.size != undefined && crData.modelNameMap.size > 0">
              <el-select v-model="modelVersion[index]" :placeholder="$t('msg.pleaseSelect')" style="width:98%" name="modelUpdated" :disabled="onlyView">
                <el-option v-for="a in crData.modelNameMap.get(item)" :key="a.id" :label="a.docName" :value="a.id"></el-option>
              </el-select>

            </el-col>          
          </el-row>
        </div>
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$t('field.criticalUpd')" prop="isCritical">  
              <el-select v-model="form.isCritical" :placeholder="$t('msg.pleaseSelect')" :disabled="onlyView">
                <el-option v-for="item in isCriticalArr"  :key="item"  :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <h3>Notice Information</h3>
        <el-row> 
          <el-col :span="24">
            <el-form-item :label="$t('field.mailTitle')"  label-width="230px" prop="mailTitle">
              <el-input v-model="form.mailTitle" :disabled="onlyView" maxlength=500></el-input>
            </el-form-item>
          </el-col>
        </el-row> 
        <el-row> 
          <el-col :span="24">
            <el-form-item :label="$t('field.cncCustomerNo')" label-width="230px" prop="mailTo">       
              <CustomerMultiSearch ref="mailTos" :pSelectValue.sync="form.mailTo"  @sync-select-cust="syncSelectCustomer"  :pOnlyView.sync="lockMaintainMail" />   
            </el-form-item>        
          </el-col>
        </el-row> 
        <el-row> 
          <el-col :span="24">
            <el-form-item :label="$t('field.informPM')" label-width="230px">
              <el-input v-model="form.mailCc" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row> 
        <!--
        <el-row> 
          <el-col :span="24">
            <el-form-item :label="$t('field.cncBcc')" label-width="230px">
              <el-input v-model="form.mailBcc" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>  -->
        <el-row>
          <el-col :span="24">
            <el-form-item  :label="$t('field.mailContent')" label-width="230px" prop="mailContent">
              <el-input type="textarea" v-model="form.mailContent"  :disabled="onlyView" maxlength=3000  show-word-limit rows=5></el-input>
              <span style="color:darkred">* 上述信件內容在執行發信時會將大括號之內容替換為藍字</span>
            </el-form-item>
          </el-col>
        </el-row> 
 
        <div v-if="form.isCritical == 'Y'">
          <h3>{{$t('field.criticalArea')}}</h3>
          <!--<el-row>  
            
            <el-col :span="24">
              <el-form-item :label="$t('field.mailTitle')" label-width="230px">
                <el-input v-model="form.criticalMailTitle" :disabled="onlyView" maxlength=500></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="24">
              <el-form-item  :label="$t('field.mailContent')" label-width="230px">
                <el-input type="textarea" v-model="form.criticalMailContent"  :disabled="onlyView" maxlength=3000  show-word-limit rows=5></el-input>              
              </el-form-item>
            </el-col>
          </el-row> 
       
        </div>
      </el-form>


      <h3>{{$t('field.signHistory')}}</h3>
      <div style="width:100%">
        <el-table ref="historyTable" :data="historyTable.data"  border  highlight-current-row  :empty-text="$t('msg.noDataFound')" >
          <el-table-column v-for="(v, i) in historyTable.columns" :prop="v.field" :label="v.title" :width="v.width" :key="i">
            <template slot-scope="scope">          
              <span>{{ scope.row[v.field] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog ref="signDialog" :title="$t('field.signDialogTitle')" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
        <el-form :model="signForm"  label-width="100px">
          <el-row>
            <el-col :span="10">
              <el-form-item :label="$t('field.signAction')" >
                <el-input v-model="signForm.signAction" :disabled="true" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="signForm.signAction=='Forward'">
            <el-col :span="24">
              <el-form-item :label="$t('field.forwardPerson')"><!-- forwardEmp -->
                <EmployeeSearch @sync-select-employee="syncForwardEmp"  />   
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('field.signComment')" >
                <el-input v-model="signForm.signComment" type="textarea" maxlength="1000" show-word-limit rows="3"></el-input>
              </el-form-item>
            </el-col>        
          </el-row>         
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{$t('button.cancel')}}</el-button>
          <el-button type="warning" @click="sendApprove">{{$t('button.submit')}}</el-button>
        </span>
      </el-dialog>

    </el-main>
  </div>
</template>

<script>
import Breadcrumb from '../components/Breadcrumb.vue'
import FileEditList from "../components/FileEditList";
import EmployeeSearch from '../components/EmployeeSearch';
import CRSearch from "../components/CRSearch";
import CustomerMultiSearch from "../components/CustomerMultiSearch";
import CommonUtil from "../../utils/commonUtil.js";
import { apiFindEmpByAdAccount, apiFindCNCById, apiFindCrDocById, apiFindProcessLogListByDocId, apiFindDocListByModel,apiFindDocNoModelRelListByTarget ,
         apiFindSwFwListByTarget, apiFindPmByCustNo, apiSaveCncDoc, apiSendApproveCNCDoc, apiHasExecuteCncMailAuth, apiExecuteCncMail, apiGetSwfwImportStatus} from "../../utils/api.js";
import authHeader from "../../services/auth-header";



export default {
  name: 'createCNC',
  data() {    
    return {     
      loading:false,
      onlyView:false,    
      dialogVisible:false,
      form:{
        id:'',
        requestNo:'',
        applyDate:'',
        applyAccount:'',
        applyDept:'',
        applyExtNo:'',
        crNo:'',
        crId:'',
        currentVersion:'',
        updateTo:'',
        isCritical:'N',
        mailTitle:'',
        mailTo:'',
        mailCc:'',
        mailContent:'',
        criticalMailTitle:'',
        criticalMailContent:'',
	      status:'',
      },
      crData:{
        reason:'',
        target:'',
        modelName:'',
        modelNameArr:[],
        description:'',
        pm:'',
        ecrNo:'',
        ecnNo:'',
        targetType:'',
        modelNameMap:new Map()
      },
      isCriticalArr:['Y','N'],
      modelVersion:[],
      rules: { 
        crNo: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'blur' }],
        isCritical: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'change' }],
        mailTitle: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'blur' }],
        mailTo: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'blur' }],
        mailContent: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'blur' }],
        updateTo: [ { required: true, message: this.$i18n.t('msg.fieldNotEmpty'), trigger: 'change' }],
      }, 
      signForm:{
        signAction:'', 
        signComment:'',
        forwardEmp:''
      },
      reasonOpts:['Customer requests', 'Customer complaints', 'New'],
      targetOpts:[],
      currentVersionOpts:[],
      updateToOpts:[],
      modelNameOpts:[],
      pRequestEmp:'',
      canSave:false, 
      canSubmit:false,
      canDelete:false,    
      canApprove:false,
      canReject:false,
      lockMaintainMail:true,
      // canForward:false,
      canSendMail:false,
      historyTable:{
        columns: [ 
          { field: "taskName", title: this.$i18n.t('field.taskName'), width: 150 },         
          { field: "assignee", title: this.$i18n.t('field.taskOwner') , width: 180  },
          { field: "startTime", title:this.$i18n.t('field.taskReceived'), width: 150 },
          { field: "endTime", title: this.$i18n.t('field.taskSigned'), width: 150  },
          { field: "status", title: this.$i18n.t('field.signAction'), width: 150 },
          { field: "approveComment", title: this.$i18n.t('field.signComment') }
        ],
        data: []
      },
      targetType:['document(有分Model)','document(不分Model)','document(Other)','document(INCX Education Training)','software','Firmware','Updated package','Other'],
      defaultMailTitle:'INCX Download update / 睿生下載更新 : {type}',
      defaultMailContent:'Dear, \nWe are now sending updated {"{type}"} for you. \nPlease download from system link. \n\n您好，{"{type}"} 已更新。請進入系統連結並下載。',
      defaultCriticalMailContent:'Since it is a critical update, please help to download and fill in the necessary items from the following link within 10 days. \nThank you.\n\n 由於這是一項重大更新，請在 10 天內下載並回填內容。\n謝謝您\n'
    };
  },  
  components: {
    Breadcrumb,
    FileEditList,
    EmployeeSearch,
    CRSearch,
    CustomerMultiSearch
  },  
  created(){ 
    this.form.id = this.$route.params.id;
    if(this.form.id == null){
      console.log("create"); 
      this.form.applyDateStr = CommonUtil.dateFormat(new Date());
      this.form.status = 'Draft';
      let loginUser = this.$store.state.auth.user.username;
      debugger
      this.canSave = true; 
      this.canDelete = true;
      this.canSubmit = true;
      this.onlyView = false; 
      this.lockMaintainMail = false;
      apiFindEmpByAdAccount({ headers: authHeader(), condition: loginUser}).then((response) => {         
        if(response.status== 200 && response.data != null && response.data != ''){    
          this.form.applyAccount = response.data.name+'('+response.data.empNo+')';
          this.form.applyDept = response.data.dept;
          this.form.applyExtNo = response.data.ext;
        }
      }).catch((err) => {  console.log(err);  });

    }else {
      console.log("modify:"+this.form.id );
    }

  },
  mounted() {   
    if(this.form.id != null && this.form.id != ''){  
      apiFindCNCById({ headers: authHeader(), condition:this.form.id}).then((response) => { 
        if(response.status== 200 && response.data != null && response.data != ''){
          this.form = response.data;
          this.form.crNo = response.data.crDoc.requestNo;
          this.crData = response.data.crDoc;
          this.genUpdateToDivData();
          apiFindProcessLogListByDocId({ headers: authHeader(), condition:this.form.id, condition1:'CNC'}).then((response) => { 
            let auth = response.data.auth;
            if(response.data.historyList.length > 0){
              this.historyTable.data = response.data.historyList;
            }
            
            this.signAuth(auth);            
            var reg=new RegExp("<br>","g");
            this.form.mailContent=this.form.mailContent.replace(reg,"\n");   
            this.form.criticalMailContent = this.form.criticalMailContent.replace(reg,"\n");   
          }).catch((err) => {
            console.log(err);
          });
        }
        
      }).catch((err) => {
        console.log(err);
      });  
        
    }
    
  },
  watch:{  
    '$route':function(){
      if(this.$route.fullPath == '/createCNC'){
   
        location.reload()
      }
    },
    "form.crNo": function(){
      this.validateCrNo()
    },
    "form.mailTo": function(){ 
      this.validateMailTo()
      if(!CommonUtil.isNull(this.form.mailTo)){
        apiFindPmByCustNo({ headers: authHeader(), condition:this.form.mailTo}).then((response) => {             
          if(response.status== 200 && response.data != null && response.data != ''){  
            this.form.mailCc = response.data;
          }
        })
      }      
    },
    "form.updateTo":function(){
      var a = this.form.updateTo; 
      if(!CommonUtil.isNull(this.form.updateTo)){
        apiGetSwfwImportStatus({ headers: authHeader(), condition:this.form.updateTo}).then((response) => {  
             
          if(response.status== 200 && response.data != null && response.data == 'Y'){  
            this.form.isCritical = response.data;
          }
        })
      } 
    },
    "form.isCritical":function(){
      if(this.form.isCritical != 'Y'){
        this.form.criticalMailContent ='';
      }else{
        if(CommonUtil.isNull(this.form.criticalMailContent)){
          this.form.criticalMailContent = this.defaultCriticalMailContent;
        }
      }
    }
  },
  methods: {
    validateCrNo(){
      if(!CommonUtil.isNull(this.form.crNo)){
        this.$refs.form.clearValidate('crNo'); 
      }
    },
    validateMailTo(){
      if(!CommonUtil.isNull(this.form.mailTo)){
        this.$refs.form.clearValidate('mailTo'); 
      }
    },
    signAuth(auth){
      this.canSave = false; 
      this.canSubmit = false;
      this.canDelete = false;
     // this.canForward = false;
      this.canApprove = false;
      this.canReject = false;
      this.canSendMail = false;
      this.onlyView = true;
      
      let lastHistory = this.historyTable.data.filter(function(item) {  
        return (item.endTime == null || item.endTime == ''  )
      }); 
      
      if(auth){
        let step = '';
        if(lastHistory.length > 0){
          step = lastHistory[0].taskName;
        }
        if(this.form.status == 'Draft' || step == 'Applicant'){
          this.canSave = true; 
          this.canDelete = true;
          this.canSubmit = true;
          this.onlyView = false;
          this.lockMaintainMail = false;
        } else {          
          if(step == 'Applicant Manager'){
            this.canApprove = true;
            this.canReject = true;
          }else if(step == 'PM'){
            this.canApprove = true;
            this.canReject = true;
            //this.canForward = true;
          }
        }
      }else{
        this.onlyView = true;
      }   
      apiHasExecuteCncMailAuth({ headers: authHeader(), condition:this.form.id}).then((response) => { 
        if(response.status== 200 && response.data != null && response.data != ''&& response.data===true){  
          this.canSendMail = true;
          this.lockMaintainMail = false;
        }
      }).catch((err) => {
        console.log(err);
      });

    }, 
    saveSubmitCheck(){
      let pass = true;
      this.validateCrNo();

      if(CommonUtil.isNull(this.form.crNo) || CommonUtil.isNull(this.form.mailTo) || CommonUtil.isNull(this.form.mailContent) || CommonUtil.isNull(this.form.mailTitle)){
        this.$message.warning({showClose: true,message: this.$i18n.t('msg.incompleteInfo'), duration: 2000});
        pass = false;
      }
      if(pass){
        if(this.form.isCritical == 'Y' && CommonUtil.isNull(this.form.criticalMailContent )){
          this.$message.warning({showClose: true,message: this.$i18n.t('msg.whenCriticalYMustFillCriticalMailInfo'), duration: 2000});
          pass = false;
        }        
      }

      // 0-> model doc 必填
      // 1 2 3->form.updateTo 必填
      // 4 5 6->form.currentVersion, form.updateTo必填
      // 7->皆非必填

      let requiredField = '';
      if(this.crData.targetType == this.targetType[0]){
        var modelUpdatedField = document.getElementsByName("modelUpdated");
        this.form.updateTo = '';
        if(modelUpdatedField != null && modelUpdatedField.length > 0){
          modelUpdatedField.forEach((item, index) => {  
            if(item.value == null || item.value == ''){              
              requiredField=  'Model Name';
            }else{
              this.form.updateTo += item.value + ';';
            }
          });
        }  
      }else if((this.crData.targetType == this.targetType[1] || this.crData.targetType == this.targetType[2] || this.crData.targetType == this.targetType[3]) &&
             CommonUtil.isNull(this.form.updateTo)){ 
        requiredField=  this.$i18n.t('field.updatedTo');
      }else if((this.crData.targetType == this.targetType[4] || this.crData.targetType == this.targetType[5] || this.crData.targetType == this.targetType[6]) && 
            (CommonUtil.isNull(this.form.currentVersion) || CommonUtil.isNull(this.form.updateTo))){  
        requiredField=  this.$i18n.t('field.updatedTo')+' , '+this.$i18n.t('field.currentVersion');
      }
      if(requiredField != ''){
        this.$message.warning({showClose: true,message: this.$i18n.t('msg.fieldRequired').replace('{field}', requiredField), duration: 2000});
        pass = false;
      }
      if(pass){
        var mailToArr = this.$refs.mailTos.selectValue; //從元件再次重新set值       
        if(mailToArr.length>0){
          this.form.mailTo = '';
          mailToArr.forEach((item, index) => {   
            this.form.mailTo += item+';';
          });
        }
        this.form.applyDate = Date.parse(this.form.applyDateStr);
      }
      return pass;
    },
    save(){   
      this.$refs['form'].validate((valid) => {      

        if(valid && this.saveSubmitCheck()){
          this.form.mailContent = this.form.mailContent.replace(/\n|\r\n/g,"<br>");
          if(!CommonUtil.isNull(this.form.criticalMailContent)){
            this.form.criticalMailContent = this.form.criticalMailContent.replace(/\n|\r\n/g,"<br>");
          }
          
          apiSaveCncDoc({ headers: authHeader(), cncDoc: this.form, signAction: this.signForm.signAction, signComment: this.signForm.signComment}).then((response) => {  
            this.dialogVisible = false;       
            if(response.status== 200 && response.data != null && response.data != ''){                  
              this.form = response.data.cncDoc;  
              this.loading = false;
              if(this.$route.fullPath.indexOf('/createCNC') != -1){
                this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 900});   
                this.$router.push("/createCNC/" + this.form.id);
                setTimeout(( () => location.reload()), 1000);
              }
            }else{
              this.loading = false;   
              this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 1000});   
            }
          }).catch((err) => {  
            console.log(err); 
            this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 1000});            
          });
        }else{
          this.$message.warning({showClose: true,message: this.$i18n.t('msg.incompleteInfo'), duration: 2000});
        }
      });
    },
    submit(){
      this.signForm.signAction = 'Submit';    
      this.signForm.signComment = '';
      this.dialogVisible = true;
      this.signForm.forwardEmp ='';
    },
    docDelete(){
      this.signForm.signAction = 'Cancelled';
      this.signForm.signComment = '';
      this.dialogVisible = true;
      this.signForm.forwardEmp ='';
    },
    forward(){
      this.signForm.signAction = 'Forward';
      this.signForm.signComment = '';
      this.dialogVisible = true;
      this.signForm.forwardEmp ='';
    },
    approve(){
      this.signForm.signAction = 'Approve';
      this.signForm.signComment = '';
      this.dialogVisible = true;
      this.signForm.forwardEmp ='';
    },
    reject(){
      this.signForm.signAction = 'Reject';
      this.signForm.signComment = '';
      this.dialogVisible = true;
      this.signForm.forwardEmp ='';
    },
    sendApprove(){
      this.signForm.signAction;
      this.signForm.signComment;
      this.signForm.forwardEmp;
      if( this.signForm.signAction=='Reject' && CommonUtil.isNull(this.signForm.signComment) ){
        return this.$message({ type: "error", message: this.$i18n.t('msg.commentRequiredWhenSignActionRejected'), duration: 1000}); 

      } else if( this.signForm.signAction=='Cancelled'  && CommonUtil.isNull(this.signForm.signComment) ){
        return this.$message({ type: "error", message: this.$i18n.t('msg.commentRequiredWhenSignActionDocDelete'), duration: 1000}); 

      } else {
        if(this.signForm.signAction == 'Submit'){
          this.save();
        }else{          
          apiSendApproveCNCDoc({ headers: authHeader(), cncDoc: this.form,signAction: this.signForm.signAction, 
                              signComment: this.signForm.signComment, forwardEmp:this.signForm.forwardEmp}).then((response) => {   
            this.dialogVisible = false;                  
            if(response.status== 200 && response.data != null && response.data != ''){
              this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 900}); 
              this.dialogVisible = false;   
              setTimeout(( () => location.reload()), 1000);
            }else{
              this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 1000});  
              this.loading = false;      
            }
          }).catch((err) => {  
            console.log(err);  
            this.dialogVisible = false;
            this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 1000});  
            });
        }
      }      
    }, 
    syncForwardEmp(empNo){
      this.signForm.forwardEmp = empNo;
    },   
    syncSelectCR(crId){
      this.form.crId = crId;  
      apiFindCrDocById({ headers: authHeader(), condition:crId}).then((response) => { 
        this.crData.reason  = response.data.reason; 
        this.crData.target  = response.data.target; 
        this.crData.modelName = response.data.modelName;      
        this.crData.description = response.data.description; 
        this.crData.pm = response.data.pm; 
        this.crData.ecrNo = response.data.ecrNo; 
        this.crData.ecnNo = response.data.ecnNo; 
        this.crData.targetType  = response.data.targetType;        
        this.form.crNo = response.data.requestNo;
        this.crData.modelNameArr = [];
        this.crData.modelNameMap = new Map();
        this.currentVersionOpts = [];           
        this.updateToOpts = []; 
        this.form.updateTo = '';
        debugger
        this.form.mailTo = response.data.custSapCode;
        
        if(CommonUtil.isNull(this.form.mailTitle)){
          this.form.mailTitle = this.defaultMailTitle.replace('{type}', this.crData.target);
        }
        if(CommonUtil.isNull(this.form.mailContent)){
          this.form.mailContent = this.defaultMailContent.replaceAll('{type}', this.crData.target);
        }
        this.genUpdateToDivData();
        
        
      }).catch((err) => {
        console.log(err);
      });  
    },
    genUpdateToDivData(){
      if(this.crData.modelName != null && this.crData.modelName != ''){
        this.crData.modelNameArr = [];
        let tempArr = this.crData.modelName.split(';');
        tempArr.forEach((item, index) => {  
          if(item != null && item != '' && item != this.targetType[7]){            
            this.crData.modelNameArr.push(item)
          }  
        })
      } 
      debugger
      //  targetType:['document(有分Model)','document(不分Model)','document(Other)','document(INCX Education Training)','software','Firmware','Updated package','Other']
      if(this.crData.targetType == this.targetType[0]){

        apiFindDocListByModel({ headers: authHeader(), condition:this.crData.modelName, condition1:this.crData.target}).then((response) => {           
          if(response.status== 200 && response.data != null && response.data != ''){                          
            let temp = new Map(Object.entries(response.data));
            if(temp != null && temp.size > 0 ){
              let cnt = 0;
              for (let e of temp) {
                this.modelVersion.push(e[1][0].docName);                  
              }

              
              this.crData.modelNameMap = temp;
              if(!CommonUtil.isNull(this.form.updateTo)){
                let updateToArr = this.form.updateTo.split(';');
                if(updateToArr.length >0){
                  this.modelVersion = [];
                  updateToArr.forEach((item, index) => {  
                    if(!CommonUtil.isNull(item)){
                      this.modelVersion.push(item);
                    }
                  });
                }        
              }
            }
          }
        })
      }else if(this.crData.targetType == this.targetType[1] || this.crData.targetType == this.targetType[2] || this.crData.targetType == this.targetType[3]){
        apiFindDocNoModelRelListByTarget({ headers: authHeader(), condition:this.crData.target}).then((response) => {   
          if(response.status== 200 && response.data != null && response.data != ''){ 
            this.updateToOpts = response.data; 
            
          }
        })
      }else if(this.crData.targetType == this.targetType[4] || this.crData.targetType == this.targetType[5] || this.crData.targetType == this.targetType[6]){          
        apiFindSwFwListByTarget({ headers: authHeader(), condition:this.crData.target}).then((response) => {   
          if(response.status== 200 && response.data != null && response.data != ''){  
            this.updateToOpts = response.data; 
            this.currentVersionOpts = response.data; 
          }
        })
      }

    },
    handleClose(done) {
      this.$confirm(this.$i18n.t('msg.confirmtoClose'),{
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      }).then(_ => {
        this.dialogVisible = false;
        done();
      }).catch(_ => {});
    },
    syncSelectCustomer(custs){
      if(custs != null && custs.length >0){
        let custStr = '';
        custs.forEach((item, index) => {
          let custCode = item.split('(')[1].replace(')','');
          custStr += custCode + ';';          
        })
        var mailToArr = this.$refs.mailTos.selectValue;
        this.form.mailTo = '';//從元件再次重新set值
        mailToArr.forEach((item, index) => {   
          this.form.mailTo += item+';';
        });
      }else{
        this.form.mailCc = '';
        this.form.mailTo = '';
      }
      
    },
    sendMail(){
      this.loading = true;
      apiExecuteCncMail({ headers: authHeader(), condition:this.form.id, condition1:this.form.mailTo}).then((response) => { 
        this.loading = false;
        if(response.status== 200 && response.data != null && response.data != ''&& response.data==true){            
          this.$message({ type: "success", message: this.$i18n.t('msg.sendMailSuccess'), duration: 1000}); 
        }else{
          this.$message({ type: "error", message: this.$i18n.t('msg.sendMailFail'), duration: 1000});  
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  
};
</script>
<style >
.el-select .el-select--small {
  width: 100%;
}

input {
  width: 100%;
}

.specialAreaStyle {
  background:#ff00000d;
  overflow: auto;
  font-size: 14px;
  padding-top: 15px;
  margin-bottom: 5px;
}


</style>


